import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import Home from './pages/Home';
import Browse from './pages/Browse';
import Movie from './pages/Movie';
import Profile from './pages/Profile';
import Watchlist from './pages/Watchlist';
import VerifyEmail from './pages/VerifyEmail';

function App() {
  return (
    <AuthProvider>
      <Router>
        <div className="App">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/browse" element={<Browse />} />
            <Route path="/movie/:id" element={<Movie />} />
            <Route path="/profile" element={<Profile />} />
            <Route path="/watchlist" element={<Watchlist />} />
            <Route path="/verify-email" element={<VerifyEmail />} />
          </Routes>
        </div>
      </Router>
    </AuthProvider>
  );
}

export default App;